import { render, staticRenderFns } from "./TemplateRelationDetailsModal.vue?vue&type=template&id=7ce58592&scoped=true"
import script from "./TemplateRelationDetailsModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./TemplateRelationDetailsModal.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./TemplateRelationDetailsModal.vue?vue&type=style&index=0&id=7ce58592&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce58592",
  null
  
)

export default component.exports